import { Modal } from "shared/components";
import { Button, ButtonVariant, ButtonSize } from "shared/components";
import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";

export const RemoveTemplateModal = (props: {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  templateName: string;
  propertyName: string;
}) => {
  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      panelClassName="w-full max-w-[366px] space-y-4 p-6 overflow-auto rounded-lg shadow-lg"
    >
      <div className="size-16 bg-danger-50 rounded-full flex items-center justify-center mx-auto">
        <HugeiconsIcon
          icon={InformationCircleIcon}
          className="size-8 text-danger-500"
        />
      </div>

      <div className="text-center space-y-2">
        <h4 className="text-xl font-bold text-content-1000">
          Remove &ldquo;{props.templateName}&rdquo; template from{" "}
          {props.propertyName}
        </h4>
        <p className="text-base font-normal text-content-500">
          Are you sure you want to remove this template?
        </p>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant={ButtonVariant.BASE}
          onClick={props.onClose}
          size={ButtonSize.BASE}
          className="flex-1 w-[155px]"
        >
          Cancel
        </Button>
        <Button
          variant={ButtonVariant.DANGER}
          onClick={props.onConfirm}
          size={ButtonSize.BASE}
          className="flex-1 w-[155px]"
        >
          Remove
        </Button>
      </div>
    </Modal>
  );
};
